// extracted by extract-css-chunks-webpack-plugin
module.exports = {"pageContainer":"css-2Gy6pf3YJ8"};